import React from 'react';
import { ArrowDown, Shield, Zap, Lock, Database } from 'lucide-react';
export function HeroSection() {
  return <section id="hero" className="relative min-h-screen flex items-center justify-center pt-20 pb-12 px-4 sm:px-6 lg:px-8 bg-[#0B1120] overflow-hidden" data-id="element-133" data-mp="2hvvttu6gppgc">
      {/* Enhanced Background decorative elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden -z-10" data-id="element-134" data-mp="28uo6261ko70i">
        <div className="absolute -top-[10%] -right-[10%] w-[40%] h-[40%] rounded-full bg-cyan-500/10 blur-3xl opacity-50 animate-pulse" data-id="element-135" data-mp="2wl0edi0qc5rm"></div>
        <div className="absolute top-[20%] -left-[10%] w-[30%] h-[30%] rounded-full bg-blue-500/10 blur-3xl opacity-50 animate-pulse" style={{
        animationDelay: '1s'
      }} data-id="element-136" data-mp="30n54i6ryyk9i"></div>
        <div className="absolute bottom-[10%] right-[20%] w-[25%] h-[25%] rounded-full bg-cyan-400/5 blur-3xl opacity-30 animate-pulse" style={{
        animationDelay: '2s'
      }} data-id="element-137" data-mp="3fi1lp9hrahyq"></div>

        {/* Floating tech icons */}
        <div className="absolute top-[15%] right-[15%] text-cyan-500/20 animate-float" data-id="element-138" data-mp="2fdfpfjjpfwq2">
          <Shield className="h-16 w-16" data-id="element-139" data-mp="2bfro9yrf57pq" />
        </div>
        <div className="absolute top-[60%] left-[10%] text-blue-500/20 animate-float" style={{
        animationDelay: '1.5s'
      }} data-id="element-140" data-mp="2p5ldii6u5tzz">
          <Lock className="h-12 w-12" data-id="element-141" data-mp="2z3hptdbieuzo" />
        </div>
        <div className="absolute bottom-[20%] right-[25%] text-cyan-400/20 animate-float" style={{
        animationDelay: '0.5s'
      }} data-id="element-142" data-mp="2z1y4v9ewrvrk">
          <Database className="h-14 w-14" data-id="element-143" data-mp="3834ovsgrnopk" />
        </div>
        <div className="absolute top-[40%] right-[5%] text-blue-400/20 animate-float" style={{
        animationDelay: '2s'
      }} data-id="element-144" data-mp="335385e6tc1h9">
          <Zap className="h-10 w-10" data-id="element-145" data-mp="1dqeul9mhkdhn" />
        </div>
      </div>

      <div className="max-w-7xl mx-auto w-full" data-id="element-146" data-mp="18s4zt04obewk">
        <div className="flex flex-col lg:flex-row items-center justify-between gap-12 lg:gap-20" data-id="element-147" data-mp="18tg2sxqaoimm">
          {/* Text Content */}
          <div className="flex-1 text-center lg:text-left order-2 lg:order-1" data-id="element-148" data-mp="3drw8zmftqiab">
            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-white tracking-tight mb-4" data-id="element-149" data-mp="3irimlwzke0jn">
              Arthur Miller
            </h1>
            <h2 className="text-xl sm:text-2xl bg-gradient-to-r from-cyan-400 to-blue-400 bg-clip-text text-transparent font-medium mb-6" data-id="element-150" data-mp="3mtvsqmi840gy">
              Founder & CEO | CTO | Enterprise Architect | Engineering Leader |
              Financial Infrastructure Innovator
            </h2>
            <p className="text-lg sm:text-xl text-slate-400 max-w-2xl mx-auto lg:mx-0 mb-10 leading-relaxed" data-id="element-151" data-mp="5ccnj9lea45t">
              Reimagining banking systems for the post-quantum era. Architecting
              trust at scale through modular infrastructure, transparency, and
              ethical innovation.
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-4" data-id="element-152" data-mp="jd5exlgegj4p">
              <a href="#about" className="px-8 py-3.5 bg-cyan-500 text-black font-semibold rounded-lg hover:bg-cyan-400 transition-colors shadow-sm hover:shadow-md w-full sm:w-auto text-center" data-id="element-153" data-mp="23vzg0urjoxkf">
                Read Biography
              </a>
              <a href="#contact" className="px-8 py-3.5 bg-white/5 text-white font-medium rounded-lg border border-white/20 hover:bg-white/10 transition-colors w-full sm:w-auto text-center" data-id="element-154" data-mp="1pw7xqhtzwv0m">
                Get in Touch
              </a>
            </div>
          </div>

          {/* Image */}
          <div className="flex-1 w-full max-w-md lg:max-w-lg order-1 lg:order-2" data-id="element-155" data-mp="28tixe3jjhqgl">
            <div className="relative" data-id="element-156" data-mp="28reu9ntgsvhd">
              <div className="absolute inset-0 bg-cyan-500 rounded-2xl transform translate-x-4 translate-y-4 opacity-20 blur-sm" data-id="element-157" data-mp="369etmzl9o99f"></div>
              <img src="https://cdn.magicpatterns.com/uploads/d5fs7fsMmGw9UFYJHyxXZ3/Screenshot_2026-03-06_at_9.46.07_AM.png" alt="Arthur Miller, Founder & CEO of FiQIS" className="relative rounded-2xl shadow-2xl object-cover w-full h-auto z-10 border border-white/10 glow-cyan" data-id="element-158" data-mp="31gltkp0qtp3o" />
            </div>
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce hidden md:block" data-id="element-159" data-mp="2h2x0szij00bs">
        <a href="#about" className="text-slate-500 hover:text-cyan-400 transition-colors" aria-label="Scroll down" data-id="element-160" data-mp="38s8iq9ed0k0o">
          <ArrowDown className="h-6 w-6" data-id="element-161" data-mp="2v0bvainmyyam" />
        </a>
      </div>
    </section>;
}